module.exports = __webpack_public_path__ + "static/media/urqo.45fed1b3.png";